//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'EvansBrooke',
  data() {
    return {
      form:{
        burn_area:'',
        weight:'',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result24 = 0
        let result48 = 0
        result24 = form.burn_area * form.weight * 2 + 2000
        result48 = form.burn_area * form.weight + 2000

        self.hasScore = true
        return {
          fluid24: String(result24),
          fluid48: String(result48),
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/EvansBrooke.vue